// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1OQ8R","detailsBorder":"styles_detailsBorder__3X_VE"};